import { functions } from '@/firebase'
import { traceHttpsCallable } from '@/utils/sentry'
import { backendClient } from '@/utils/backendClient'
import { adminApiConfig, type AdminRouteTypeMap } from 'functions-node-admin/client'
import type { GenerateCustomTokenResponse } from '@gh/common/models'

type RefreshPaymentMethodInputsForCustomerRequest = {
  customerId: string
}

type RefreshPaymentMethodInputsForCustomerResponse = {
  success: boolean
  message: string
}

type RefreshPaymentMethodInputsForAllCustomersResponse = {
  success: boolean
  message: string
  runId: string
  enqueuedCount: number
  skippedCount: number
}

type SyncAllCustomersToCustomerIoResponse = {
  success: boolean
  message: string
  processedCount: number
  succeededCount: number
  failedCount: number
  failedCustomerIds: string[]
}

const adminGateway = backendClient<AdminRouteTypeMap>(adminApiConfig)

export const Admin = {
  ...adminGateway,
  generateCustomTokenForCustomer: traceHttpsCallable<object, GenerateCustomTokenResponse>(
    functions,
    'admin_generateCustomTokenForCustomer',
  ),
  refreshPaymentMethodInputsForCustomer: traceHttpsCallable<
    RefreshPaymentMethodInputsForCustomerRequest,
    RefreshPaymentMethodInputsForCustomerResponse
  >(functions, 'admin_refreshPaymentMethodInputsForCustomer'),
  refreshPaymentMethodInputsForAllCustomers: traceHttpsCallable<
    object,
    RefreshPaymentMethodInputsForAllCustomersResponse
  >(functions, 'admin_refreshPaymentMethodInputsForAllCustomers'),
  syncAllCustomersToCustomerIo: traceHttpsCallable<object, SyncAllCustomersToCustomerIoResponse>(
    functions,
    'admin_syncAllCustomersToCustomerIo',
  ),
}
